// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/hl7-front-library";
// Components
import JunoPage from "../../components/JunoPage/JunoPage";
// Translation
import i18n from "i18next";
// Styles
import "../Home/Home.css"

const Home: FunctionComponent = () => {
  //////////////////////////////
  //          Content         //
  //////////////////////////////

  return (
    <JunoPage loading={false} fitFooter={true} needsLogin={false}>
      <>
        <div className="h-100 d-flex justify-content-center align-items-center flex-md-row flex-column gap-3">
          <div>
            <img
              className="home-image-icon"
              alt="Home_image"
              src={(process.env.PUBLIC_URL ?? "") + "/assets/home.png"}
            />
          </div>
          <div>
            <Title
              level={1}
              prefix="Juno"
              content={i18n.t("title.usermanagement")}
            />
          </div>
        </div>
      </>
    </JunoPage>
  );
};

export default Home;
